import { ReactElement } from "react";

import { GetWorkflowTemplateResponse } from "../../../../../../../../../service/query";
import { Column, FlyoutPanel, Row } from "../../../../../../../../../widget";
import { PageSelector, ProjectSelection } from "..";
import { WorkflowPermissions } from "../WorkflowPermissions";
import { useProjectApplyWorkflowTemplatePanel } from "./useProjectApplyWorkflowTemplatePanel";

interface ProjectApplyWorkflowTemplatePanelProps {
  defaultProjectUuid?: string;
  workflowTemplateUuid: string | undefined;
  workflowTemplate: GetWorkflowTemplateResponse | undefined;
  show: boolean;
  onClose: () => void;
}

export const ProjectApplyWorkflowTemplatePanel = ({
  defaultProjectUuid,
  workflowTemplateUuid,
  workflowTemplate,
  show,
  onClose,
}: ProjectApplyWorkflowTemplatePanelProps): JSX.Element => {
  const {
    errors,
    setErrors,
    projectList,
    getProjects,
    selectedProject,
    setSelectedProject,
    showPermissionsPanel,
    setShowPermissionsPanel,
    isHandleSubmitProjectPhaseDatesLoading,
    handleClearSelection,
    handleSubmitProjectPhaseDates,
    handleSubmitProjectPhaseDatesForm,
    handleClose,
  } = useProjectApplyWorkflowTemplatePanel({ workflowTemplate, onClose });

  const content = (): ReactElement => {
    return (
      <>
        <Row spacingV="xl">
          <Column span={12}>
            <p className="body1">
              {!showPermissionsPanel
                ? "When applying the selected workflow to a new project, the template set of phases, steps, and related tasks will be assigned to the project based on its current status."
                : "Workflow permissions determine the level of access each organisation with access to the project will have. Any organisation without an access level for the workflow will not have visibility of the project's tasks and progress, including any they've been assigned by another participant. "}
            </p>
          </Column>
        </Row>
        <Row spacingV="xl">
          <Column span={12}>
            <PageSelector
              showPermissionsPage={showPermissionsPanel}
              setShowPermissionsPage={setShowPermissionsPanel}
              handleSubmitProjectPhaseDates={handleSubmitProjectPhaseDates}
            />
          </Column>
        </Row>
        <Row>
          <Column span={12}>
            {!showPermissionsPanel ? (
              <ProjectSelection
                errors={errors}
                defaultProjectUuid={defaultProjectUuid}
                projectsList={projectList}
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
                handleClearSelection={handleClearSelection}
                onProjectsSearch={getProjects}
                handleSubmitProjectPhaseDatesForm={handleSubmitProjectPhaseDatesForm}
                isHandleSubmitProjectPhaseDatesLoading={isHandleSubmitProjectPhaseDatesLoading}
                handleClose={handleClose}
              />
            ) : (
              <WorkflowPermissions
                workflowTemplateUuid={workflowTemplateUuid}
                selectedProject={selectedProject}
                errors={errors}
                setErrors={setErrors}
                onClose={handleClose}
              />
            )}
          </Column>
        </Row>
      </>
    );
  };

  return (
    <FlyoutPanel
      show={show}
      onClose={handleClose}
      size="Large"
      header="Apply workflow template to a project"
      buttonsChildren={undefined}
      contentChildren={content()}
    />
  );
};
